/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registrationnumberrequired2Inputs */

const en_registrationnumberrequired2 = /** @type {(inputs: Registrationnumberrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company registration number is required`)
};

const de_registrationnumberrequired2 = /** @type {(inputs: Registrationnumberrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenbuchnummer ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Company registration number is required" |
*
* @param {Registrationnumberrequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const registrationnumberrequired2 = /** @type {((inputs?: Registrationnumberrequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registrationnumberrequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_registrationnumberrequired2(inputs)
	return de_registrationnumberrequired2(inputs)
});
export { registrationnumberrequired2 as "registrationNumberRequired" }